module.exports = __webpack_public_path__ + "img/28.2d68515c.png";